import * as tslib_1 from "tslib";
import { Injector, OnInit } from '@angular/core';
import { SecondPageIndexBase } from '../../classes/base/second-page-index-base';
import { UserLogService } from '../../services/user-log.service';
import { environment } from '../../../../environments/environment';
export class LogUserChangesComponent extends SecondPageIndexBase {
    constructor(_injector, _userLogs) {
        super(null, _injector);
        this._injector = _injector;
        this._userLogs = _userLogs;
        this.dynamicCols = [];
    }
    ngOnInit() {
        this.cols = [
            {
                field: 'invoiceTaxCode',
                header: 'Mã số thuế',
                visible: true,
                align: 'center',
                width: '12%',
            },
            {
                field: 'code',
                header: 'Mã khách hàng',
                visible: true,
                align: 'center',
                width: '10%',
            },
            {
                field: 'name',
                header: 'Tên KH',
                visible: true,
                align: 'center',
                width: '10%',
            },
            {
                field: 'phone',
                header: 'SĐT',
                visible: true,
                align: 'center',
                width: '10%',
            },
            {
                field: 'fullAddress',
                header: 'Địa chỉ',
                visible: true,
                align: 'center',
                width: '30%',
            },
            {
                field: 'lng',
                header: 'Kinh độ',
                visible: true,
                align: 'center',
                width: '10%',
            },
            {
                field: 'lat',
                header: 'Vĩ độ',
                visible: true,
                align: 'center',
                width: '10%',
            }
        ];
        this.getUserLog();
        // this.compareUserTempSteps();
    }
    getUserLog() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.userId) {
                yield this._userLogs.LogChangeInfomation(this.userId)
                    .then((response) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (response.status) {
                        const data = response.data.sort((a, b) => new Date(b.updatedDate).getTime() - new Date(a.updatedDate).getTime());
                        this.extractDynamicColumns(data);
                        this.dataSource = this.markChanges(data);
                        this.total = response.totalRecord;
                    }
                }), () => {
                    this._notifierService.showHttpUnknowError();
                });
            }
        });
    }
    // async compareUserTempSteps() {
    //   if (this.userId) {
    //     await this._userLogs.CompareUserTempSteps(this.userId)
    //       .then(async response => {
    //         if (response.status) {
    //           const data = response.data.reverse();
    //           this.dataTest = this.markChanges(data);
    //           this.total = response.totalRecord;
    //         }
    //       }, () => {
    //         this._notifierService.showHttpUnknowError();
    //       });
    //   }
    // }
    markChanges(data) {
        for (let i = 1; i < data.length; i++) {
            const currentRecord = data[i];
            const previousRecord = data[i - 1];
            currentRecord.changes = {};
            const fieldsToCheck = ['invoiceTaxCode', 'code', 'name', 'phone', 'fullAddress', 'lng', 'lat'];
            for (const field of fieldsToCheck) {
                if (currentRecord[field] !== previousRecord[field]) {
                    currentRecord.changes[field] = true;
                }
            }
        }
        console.log(data);
        return data;
    }
    extractDynamicColumns(data) {
        const dynamicFieldsSet = new Set();
        data.forEach(item => {
            if (item.dynamicFields) {
                Object.keys(item.dynamicFields).forEach(field => {
                    dynamicFieldsSet.add(field);
                });
            }
        });
        this.dynamicCols = Array.from(dynamicFieldsSet).map(field => ({
            field: 'dynamicFields.' + field,
            header: this.getHeaderName(field),
            visible: true,
            align: 'center',
            width: '15%',
            isDynamic: true
        }));
        this.cols = this.cols.concat(this.dynamicCols);
    }
    getHeaderName(field) {
        const fieldMap = {
            'certificateDkdn': 'Ảnh đăng ký kinh doanh',
            'certificateNumberDkdn': 'Số đăng ký doanh nghiệp',
            'certificateDkdnDate': 'Ngày đăng ký doanh nghiệp',
            'certificateGdpGppDsp': 'Ảnh GDP/GPP/DSP',
            'certificateNumberGdpGppDsp': 'Số GDP/GPP/DSP',
            'certificateGdpGppDspDate': 'Ngày GDP/GPP/DSP',
            'certificateGdpGppDspExpirationDate': 'Ngày hết hạn GDP',
            'certificateDdkkd': 'Ảnh đủ Ddkkd',
            'certificateNumberDdkkd': 'Số giấy tờ Ddkkd',
            'certificateDdkkdDate': 'Ngày giấy tờ Ddkkd',
            'isApproved': 'Đã duyệt',
            'invoiceTaxCodeNew': 'Mã số thuế mới',
            'idWard': 'Mã Phường/Xã',
            'idProvice': 'Mã Tỉnh/Thành phố',
            'idDistrict': 'Mã Quận/Huyện',
            'invoiceCompanyName': 'Mã hoá đơn Công ty',
            'invoiceAddress': 'Địa chỉ hoá đơn',
            'placeOfIssueDkdn': 'Mã nơi cấp Dkdn'
        };
        return fieldMap[field] || field;
    }
    isImageField(field) {
        const imageFields = ['certificateDkdn', 'certificateGdpGppDsp', 'certificateDdkkd'];
        return imageFields.includes(field);
    }
    getDynamicFieldValue(item, fieldPath) {
        const parts = fieldPath.split('.');
        let value = item;
        for (const part of parts) {
            value = value ? value[part] : null;
        }
        return value;
    }
    getImageAvatar(id) {
        return id ? `${environment.apiDomain.fileEndpoint}/files/image/Avatar/${id}` : null;
    }
    isDateField(field) {
        const dateFields = [
            'certificateDkdnDate',
            'certificateGdpGppDspDate',
            'certificateDdkkdDate'
        ];
        return dateFields.includes(field);
    }
}
